<template>
  <div>
    <v-dialog v-model="isShowDeleteDialog" max-width="500px" persistent>
      <v-card>
        <v-card-title class="text-h5">{{ $t(deleteMessage) }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="closeDelete"
            :disabled="isAllTextFieldDisable"
            >{{ $t("common_cancel") }}</v-btn
          >
          <v-btn color="red darken-1" text @click="confirmDelete" :loading="isLoadingSaveBtn">{{
            $t("common_delete")
          }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'DeleteDialog',
  props: ['isLoadingSaveBtn', 'isAllTextFieldDisable', 'isShowDeleteDialog', 'deleteMessage'],
  data: () => ({}),
  methods: {
    closeDelete () {
      this.$emit('closeDelete')
    },
    confirmDelete () {
      this.$emit('confirmDelete')
    }
  }
}
</script>
